module.exports = __webpack_public_path__ + "img/home-hero.b135f5fe.svg";